import DashboardBannerWebCreate from "./dashboardBannerWebCreate";
import DashboardBannerWebEdit from "./dashboardBannerWebEdit";
import DashboardBannerWebList from "./dashboardBannerWebList";

export default {
  create: DashboardBannerWebCreate,
  list: DashboardBannerWebList,
  edit: DashboardBannerWebEdit,
};
